import React from "react";
import DecorPage from "./DecorPage";

const ReturnGiftPage = () => (
  <DecorPage categoryName="Return Gifts" title="Return Gifts" />
);

export default ReturnGiftPage;
